import {ActivityBatchReadTypes} from '../../constants/activity';

// ISSUES_FETCH_START and ISSUES_FETCH_END pertain to an entire batch-fetch operation:
export const ISSUES_FETCH_START = 'ISSUES_FETCH_START';
export const ISSUES_FETCH_END = 'ISSUES_FETCH_END'; //not a promise-based action payload, so it's not "_FULFILLED" :
export const ISSUES_COLLECTION_RESET = 'ISSUES_COLLECTION_RESET';
export const ISSUES_FETCH_LOADING_START = 'ISSUES_FETCH_LOADING_START';
export const ISSUES_FETCH_API = 'ISSUES_FETCH_API';
export const ISSUES_FETCH_API_PENDING = 'ISSUES_FETCH_API_PENDING';
export const ISSUES_FETCH_API_FULFILLED = 'ISSUES_FETCH_API_FULFILLED';
export const ISSUES_FETCH_API_REJECTED = 'ISSUES_FETCH_API_REJECTED';
export const ISSUES_FETCH_PAYLOAD_INJECT = 'ISSUES_FETCH_PAYLOAD_INJECT';
export const ISSUES_FETCH_REPORT_START = 'ISSUES_FETCH_REPORT_START';
export const ISSUES_FETCH_REPORT_API = 'ISSUES_FETCH_REPORT_API';
export const ISSUES_FETCH_REPORT_API_FULFILLED = 'ISSUES_FETCH_REPORT_API_FULFILLED';
export const ISSUES_FETCH_REPORT_API_REJECTED = 'ISSUES_FETCH_REPORT_API_REJECTED';
export const ISSUE_INSTANCE_FETCH_START = 'ISSUE_INSTANCE_FETCH_START';
export const ISSUE_INSTANCE_FETCH_API = 'ISSUE_INSTANCE_FETCH_API';
export const ISSUE_INSTANCE_FETCH_API_PENDING = 'ISSUE_INSTANCE_FETCH_API_PENDING';
export const ISSUE_INSTANCE_FETCH_API_FULFILLED = 'ISSUE_INSTANCE_FETCH_API_FULFILLED';
export const ISSUE_INSTANCE_FETCH_API_REJECTED = 'ISSUE_INSTANCE_FETCH_API_REJECTED';
export const ISSUE_INSTANCE_FETCH_PAYLOAD_INJECT = 'ISSUE_INSTANCE_FETCH_PAYLOAD_INJECT';
export const ISSUE_CREATE_START = 'ISSUE_CREATE_START';
export const ISSUE_CREATE_API = 'ISSUE_CREATE_API';
export const ISSUE_CREATE_API_PENDING = 'ISSUE_CREATE_API_PENDING';
export const ISSUE_CREATE_API_FULFILLED = 'ISSUE_CREATE_API_FULFILLED';
export const ISSUE_CREATE_API_REJECTED = 'ISSUE_CREATE_API_REJECTED';
export const ISSUE_UPDATE_START = 'ISSUE_UPDATE_START';
export const ISSUE_UPDATE_API = 'ISSUE_UPDATE_API';
export const ISSUE_UPDATE_API_PENDING = 'ISSUE_UPDATE_API_PENDING';
export const ISSUE_UPDATE_API_FULFILLED = 'ISSUE_UPDATE_API_FULFILLED';
export const ISSUE_UPDATE_API_REJECTED = 'ISSUE_UPDATE_API_REJECTED';
export const REMOVE_ISSUE_FROM_COLLECTION = 'REMOVE_ISSUE_FROM_COLLECTION';
export const ATTACHMENTS_FETCH_START = 'ATTACHMENTS_FETCH_START';
export const ATTACHMENTS_FETCH_API_FULFILLED = 'ATTACHMENTS_FETCH_API_FULFILLED';
export const ATTACHMENTS_FETCH_API_REJECTED = 'ATTACHMENTS_FETCH_API_REJECTED';
export const ACTIVITIES_FETCH_START = 'ACTIVITIES_FETCH_START';
export const ACTIVITIES_FETCH_API = 'ACTIVITIES_FETCH_API';
export const ACTIVITIES_FETCH_API_FULFILLED = 'ACTIVITIES_FETCH_API_FULFILLED';
export const ACTIVITIES_FETCH_API_REJECTED = 'ACTIVITIES_FETCH_API_REJECTED';
export const ACTIVITIES_FETCH_API_SET_BLOCKS = 'ACTIVITIES_FETCH_API_SET_BLOCKS';
export const ACTIVITIES_SET_DUMMY_BLOCK = 'ACTIVITIES_SET_DUMMY_BLOCK';
export const ACTIVITIES_LOAD_MORE = 'ACTIVITIES_LOAD_MORE';
export const COMMENT_CREATE_START = 'COMMENT_CREATE_START';
export const COMMENT_CREATE_API = 'COMMENT_CREATE_API';
export const COMMENT_CREATE_API_PENDING = 'COMMENT_CREATE_API_PENDING';
export const COMMENT_CREATE_API_FULFILLED = 'COMMENT_CREATE_API_FULFILLED';
export const COMMENT_CREATE_API_REJECTED = 'COMMENT_CREATE_API_REJECTED';
export const PREVIEW_ISSUE_ID_SET = 'PREVIEW_ISSUE_ID_SET';
export const SHOW_NEW_ISSUE_MODAL = 'SHOW_NEW_ISSUE_MODAL';
export const ISSUES_FETCH_SEARCH_START = 'ISSUES_FETCH_SEARCH_START';
export const ISSUES_FETCH_SEARCH_API = 'ISSUES_FETCH_SEARCH_API';
export const ISSUES_FETCH_SEARCH_API_FULFILLED = 'ISSUES_FETCH_SEARCH_API_FULFILLED';
export const ISSUES_CLEAR_SEARCH = 'ISSUES_CLEAR_SEARCH';
export const SET_ISSUE_IDS_FILTER = 'SET_ISSUE_IDS_FILTER';
export const LINK_ISSUE_TO_ENTITY = 'LINK_ISSUE_TO_ENTITY';
export const UNLINK_ISSUE_FROM_ENTITY = 'UNLINK_ISSUE_FROM_ENTITY';

export const fetchIssuesAction = (payload, meta = {}) => ({
  type: ISSUES_FETCH_START,
  meta,
  payload
});

export const fetchIssuesReport = (payload, meta = {}) => ({
  type: ISSUES_FETCH_REPORT_START,
  meta,
  payload
});

export const fetchIssueInstanceAction = (issueId, isDeepLinking) => ({
  type: ISSUE_INSTANCE_FETCH_START,
  payload: issueId,
  meta: {isDeepLinking}
});

export const createIssueAction = (issueAttributes, {onSuccess, onError, isDeepLinking, issuePushpinId} = {}) => ({
  type: ISSUE_CREATE_START,
  meta: {onSuccess, onError, isDeepLinking, issuePushpinId},
  payload: issueAttributes
});

export const removeIssueFromCollectionAction = id => ({
  type: REMOVE_ISSUE_FROM_COLLECTION,
  payload: id
});

export const updateIssueAction = (issue, attributes, meta = {}) => ({
  type: ISSUE_UPDATE_START,
  meta,
  payload: {issue, attributes}
});

export const fetchAttachmentsAction = ({issueId, offset = 0}) => (dispatch, getState, {issuesV2Api}) => {
  dispatch({
    type: ATTACHMENTS_FETCH_START,
    payload: issueId
  });
  issuesV2Api.getAttachments(issueId, {offset}).then(
    ({results: payload, pagination}) => {
      dispatch({
        type: ATTACHMENTS_FETCH_API_FULFILLED,
        payload,
        meta: {id: issueId, offset, totalResults: pagination.totalResults}
      });
    },
    payload => {
      dispatch({type: ATTACHMENTS_FETCH_API_REJECTED, payload});
    }
  );
};

export const fetchActivities = ({
  issueId,
  readType = ActivityBatchReadTypes.PREVIOUS,
  offset = 0,
  triggerId,
  triggerTimestamp
}) => ({
  type: ACTIVITIES_FETCH_START,
  payload: {issueId, readType, offset},
  meta: {
    triggerId,
    triggerTimestamp
  }
});

export const setActivitiesDummyBlock = ({actor, firstActivityDate, activities}) => ({
  type: ACTIVITIES_SET_DUMMY_BLOCK,
  payload: {
    actor,
    firstActivityDate,
    activities,
    activityList: activities
  }
});

export const loadMoreActivities = ({issueId}) => ({
  type: ACTIVITIES_LOAD_MORE,
  payload: {issueId}
});

export const createCommentAction = (issueId, comment, resolve, reject) => ({
  type: COMMENT_CREATE_START,
  meta: {
    id: issueId,
    resolve,
    reject
  },
  payload: comment
});

export const setPreviewIssueIdAction = issueId => ({
  type: PREVIEW_ISSUE_ID_SET,
  payload: issueId
});

export const showNewIssueModalAction = visible => ({
  type: SHOW_NEW_ISSUE_MODAL,
  payload: visible
});

export const getSearchResultsAction = search => ({
  type: ISSUES_FETCH_SEARCH_START,
  payload: search
});

export const clearSearchResultsAction = () => ({
  type: ISSUES_CLEAR_SEARCH
});

export const setIssueIdsFilterAction = issueIdsFilter => ({
  type: SET_ISSUE_IDS_FILTER,
  payload: issueIdsFilter
});

export const linkIssueToEntityAction = (issueId, addedLinks, resolve, reject) => ({
  type: LINK_ISSUE_TO_ENTITY,
  meta: {
    id: issueId,
    resolve,
    reject
  },
  payload: {addedLinks}
});

export const unlinkIssueFromEntityAction = (issueId, removedLink, resolve, reject) => ({
  type: UNLINK_ISSUE_FROM_ENTITY,
  meta: {
    id: issueId,
    resolve,
    reject
  },
  payload: {removedLink}
});
